<template>

   <div class="container mx-auto p-8">
    <div class="text-center mb-12">
        <h2 class="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">Vacatures</h2>
        <p class="text-lg text-gray-600">
          Bekijk hier alle openstaande vacatures!
        </p>
      </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <Vacature
        v-for="(vacature, index) in vacatures"
        :key="index"
        :title="vacature.title"
        :subtitle="vacature.subtitle"
      />
    </div>
  </div>
  </template>
  
  <script>
  import Vacature from "@/components/Vacature.vue";
  
  export default {
    name: "VacatureTotaal",
    components: {
      Vacature,
    },
    data() {
      return {
        vacatures: [
          {
            title: "Verkoopmedewerker",
            subtitle: "Wij zoeken een enthousiaste en klantgerichte verkoper voor ons team! Functie voor 16 uur per week.",
          },
          {
            title: "Zaterdaghulp",
            subtitle: "Ben jij opzoek naar een leuke bijbaan voor op zaterdag en ben jij ouder dan 16 jaar? Dan zoeken we jou!",
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  /* Voeg styling naar wens toe */
  </style>
  